import { render } from "./ProductSelectModal.vue?vue&type=template&id=022f27f3&scoped=true"
import script from "./ProductSelectModal.vue?vue&type=script&lang=js"
export * from "./ProductSelectModal.vue?vue&type=script&lang=js"

import "./ProductSelectModal.vue?vue&type=style&index=0&id=022f27f3&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022f27f3"]])

export default __exports__